/**
 * @desc 批量上传tms结算附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.BatchImportSettlementRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/batchImportSettlementFile`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
